import { render, staticRenderFns } from "./FormWhatsapp.vue?vue&type=template&id=74824a72"
import script from "./FormWhatsapp.vue?vue&type=script&lang=js"
export * from "./FormWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports